<template>
  <span class="imagem-carregavel" :aria-busy="!carregada && !falhou">
    <span v-if="!carregada && !falhou" class="imagem-skeleton imagem-skeleton-animado" aria-hidden="true"></span>
    <img v-if="urlAtual && !falhou" :key="urlAtual" :src="urlAtual" :alt="alt"
         :loading="lazy && prioridade !== 'high' ? 'lazy' : 'eager'" :fetchpriority="prioridade"
         :style="{opacity: carregada ? 1 : 0}" decoding="async" @load="tratarCarregamento" @error="tratarErro" />
  </span>
</template>

<script>
export default {
  name: 'ImagemCarregavel',
  props: {
    src: {type: String, default: ''},
    fallback: {type: String, default: ''},
    alt: {type: String, default: ''},
    lazy: Boolean,
    prioridade: {type: String, default: 'auto'}
  },
  data() {
    return {urlAtual: '', carregada: false, falhou: false, usandoFallback: false};
  },
  watch: {
    src: {immediate: true, handler() { this.reiniciar(); }},
    fallback() { this.reiniciar(); }
  },
  methods: {
    reiniciar() {
      this.urlAtual = this.src || this.fallback;
      this.carregada = false;
      this.falhou = !this.urlAtual;
      this.usandoFallback = !this.src || this.src === this.fallback;
    },
    tratarCarregamento() {
      this.carregada = true;
      this.falhou = false;
    },
    tratarErro() {
      this.carregada = false;
      if (this.fallback && !this.usandoFallback) {
        this.usandoFallback = true;
        this.urlAtual = this.fallback;
        return;
      }
      this.falhou = true;
      this.$emit('error');
    }
  }
};
</script>

<style scoped>
.imagem-carregavel { display: inline-block; position: relative; overflow: hidden; vertical-align: middle; }
.imagem-carregavel img { display: block; width: 100%; height: 100%; object-fit: inherit; object-position: inherit; }
.imagem-skeleton { position: absolute; inset: 0; border-radius: inherit; background: #e9ecef; overflow: hidden; }
.imagem-skeleton-animado::after { content: ''; position: absolute; inset: 0; background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.45), transparent); transform: translateX(-100%); animation: imagem-brilho 1.8s ease-in-out infinite; }
@keyframes imagem-brilho { to { transform: translateX(100%); } }
@media (prefers-reduced-motion: reduce) { .imagem-skeleton-animado::after { animation: none; display: none; } }
</style>
